<template>
  <div class="product">
    <div>
      <div
        class="header-main web"
        :style="{
          backgroundImage:
            'url(' + require('../assets/img/footer_bg.24952d8.png') + ')',
        }"
      >
        <ul class="link-list">
          <div class="header-img">
            <img
              src="../assets/img/emotibot_logo.c18e704.png"
              class="logo"
              alt=""
            />
          </div>
          <li class="">
            <span class="" @click="downloadIndex(1)">首页</span>
            <!---->
          </li>
          <li class="active"><span class="active">软件下载</span></li>
          <li class="">
            <span class="" @click="downloadIndex(2)">关于我们</span>
          </li>
        </ul>
      </div>
      <div
        class="wrap"
        :style="{
          backgroundImage:
            'url(' + require('../assets/img/footer_bg.24952d8.png') + ')',
        }"
      >
        <div class="wrap-nav">
          <img
            src="../assets/img/emotibot_logo.c18e704.png"
            alt=""
            style="width: 128px; padding-top: 30px; height: 128px"
          />
          <span> <i class="el-icon-menu" @click="openList()"></i></span>
        </div>
        <ul class="wrap-nav-list" :style="menuShowFlag">
          <li @click="downloadIndex(1)">
            <span>首页</span>
            <!---->
          </li>
          <li>
            <span>软件下载</span>
            <!---->
          </li>
          <li @click="downloadIndex(2)" style="z-index=100">
            <span>关于我们</span>
            <!---->
          </li>
        </ul>
      </div>
    </div>

    <div class="banner">
      <div class="web web-box">
        <img src="../assets/images/banner/home_banner_web_BG6.png" alt="" />
        <div class="banner-content">
          <div class="desc-content">
            <p class="desc-large">Optimus Prime RPA</p>
            <p class="desc-normal">
              Optimus Prime RPA
              AI流程机器人技术，是一个使用软件技术将手工工作自动化的流程优化数字化服务方案，是B端乃至C端提高工效的有效手段。机器人的作用是代替人工完成。
            </p>
            <span class="blue-btn link-more" @click="downloadSoftWare()"
              >软件下载</span
            >
          </div>
          <!---->
        </div>
      </div>
      <div class="wrap">
        <img src="../assets/images/banner/home_banner_web_BG6.png" alt="" />
        <div class="banner-content">
          <div class="desc-content">
            <p class="desc-large"></p>
            <p class="desc-normal" style="padding-top: 100px"></p>
            <span class="blue-btn link-more" @click="downloadSoftWare()"
              >软件下载</span
            >
          </div>
          <!---->
        </div>
      </div>
    </div>
    <div class="product-bg">
      <div class="content-center content-center-product">
        <div class="product-desc">
          <p class="wrap product-title-wrap">安装</p>
          <div class="title-box web">
            <p class="title-first">安装</p>
          </div>
          <ul class="product-item">
            <li>
              <div class="top">
                <div class="flex-header">
                  <div class="icon-name">
                    <img
                      src="../assets/images/icon/yxhj.png"
                      alt=""
                      style="width: 64px; height: 64px"
                    />
                    <p class="title web">运行环境</p>
                  </div>
                  <div>
                    <p class="title wrap">运行环境</p>
                    <p class="second_title web">AI机器人工厂平台</p>
                    <p class="desc">
                      1)处理器：Intel Core i5 2GHz及以上<br />
                      2)内存RAM：4G及以上<br />
                      3)硬盘空间：2G以上可用空间<br />
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="top">
                <div class="flex-header">
                  <div class="icon-name">
                    <img
                      src="../assets/images/icon/zct.png"
                      alt=""
                      style="width: 64px; height: 64px"
                    />
                    <p class="title web">支持软件</p>
                  </div>
                  <div>
                    <p class="title wrap">支持软件</p>
                    <p class="second_title web">客户联络中心解决方案平台</p>
                    <p class="desc">
                      1)操作系统名称：Windows 7 SP1或以上，Windows Server 2008
                      R2 SP1或以上，建议Windows 10 64bit。<br />
                      2)运行所需组件：.NetFramework 4.6.2或以上,
                      VC++2019的运行时组件(Microsoft VC++ 2019
                      Redistributable)<br />
                      3)浏览器：IE 9以上，Chrome<br />
                      <span style="color: red">
                        4)其他可选：Office 2013或以上。</span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="footer-main"
      :style="{
        backgroundImage:
          'url(' + require('../assets/img/footer_bg.24952d8.png') + ')',
      }"
    >
      <div class="content-center web">
        <div class="footer-box">
          <div class="footer-left">
            <ul class="item-box">
              <li class="footer-item1">
                <span
                  >加入我们：liuxinyu@jiyu-ai.com<br />
                  商务合作：chentianyu@jiyu-ai.com<br />
                  技术支持：liqiangjian@jiyu-ai.com<br />
                  联系电话：13916027955<br />
                  公司地址：上海市浦东新区龙阳路2277号永达国际大厦9楼903室
                </span>
              </li>
              <li data-v-2f6d6da0="" class="footer-item1">
                <span
                  >联系电话：13916027955<br />
                  公司地址：辽宁省铁岭市银州区柴河街道卧龙馨园1幢1-12(二层)
                </span>
              </li>
              <li data-v-2f6d6da0="" class="footer-item1">
                <span
                >联系电话：13916027955<br />
                  公司地址：河南省驻马店市新蔡县弥陀寺乡林场西街派出所北100米40号
                </span>
              </li>
            </ul>
          </div>
          <ul data-v-2f6d6da0="" class="footer-right">
            <li data-v-2f6d6da0="">
              <img
                data-v-2f6d6da0=""
                src="../assets/images/code/wechat.jpg"
                alt=""
              />
              <p data-v-2f6d6da0="">霁宇智能公众号</p>
            </li>
          </ul>
        </div>
        <div class="copy-right">
          <span
            >Copyright © 2026 上海霁宇智能信息科技有限公司 All Rights Reserved ·
            <a
              href="http://www.beian.miit.gov.cn"
              target="_blank"
              rel="noopener noreferrer"
            ></a>
          </span>
          <span>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502015630"
              target="_blank"
              rel="noopener noreferrer"
              >沪ICP备2025152194号-2 </a
            ></span
          >
        </div>
      </div>

      <p class="wrap copy-text">
        Copyright © 2026 上海霁宇智能信息科技有限公司 All Rights Reserved ·
      </p>
    </div>
  </div>
</template>
<script>
import $ from "jquery"; //在需要使用的页面中
export default {
  data() {
    return {
      menuShowFlag: "display: none;",
      menuShowIndex: 0,
    };
  },
  methods: {
    openList() {
      if (this.menuShowIndex == 0) {
        this.menuShowFlag = "display: block;";
        this.menuShowIndex = 1;
      } else {
        this.menuShowFlag = "display: none;";
        this.menuShowIndex = 0;
      }
    },
    downloadSoftWare() {
      $.ajax({
        type: "GET",
        url: "http://www.op-rpa.com/static/softWareList.json",
        dataType: "json",
        success: function (data) {
          var testJson = data;
          var maxIndex = 1;
          let url = "";
          for (var i = 0; i < testJson.length; i++) {
            if (maxIndex <= testJson[i].index) {
              maxIndex = testJson[i].index;
              url = testJson[i].url;
            }
          }
          window.location.href = url;
        },
      });
    },
    downloadIndex(id) {
      if (id == 1) {
        //直接跳转
        this.$router.push({ path: "/" });
      } else {
        console.log(1);
        this.$router.push({ path: "/contact" });
      }
    },
  },
};
</script>
<style scoped>
.product-desc .product-item li {
  width: 48% !important;
}
@media (max-width: 767px) {
  .product-desc .product-item li {
    width: 100% !important;
  }
}
</style>
